'use client';

import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL, TOAST_STYLE_ERROR, TOAST_STYLE_SUCCESS } from '../../utils/constants';
import auth from '../../Auth';
import { Check, Loader2, X } from 'lucide-react';
import Breadcrumbs from '../Breadcrumbs';
import { Textarea } from '@nextui-org/react';
import JsonEditorViewer from './JsonEditorViewer';
import {Button} from '@nextui-org/react';
import { toast } from 'react-toastify';


const VersionTestResult = () => {
  const { prompt_id, test_id, prompt_version, timestamp} = useParams();

  const [testResults, setTestResults] = useState({})
  const [testName, setTestName] = useState('')
  const [isFetchedTestResults, setIsFetchedTestResults] = useState(false)
  const [testContext, setTestContext] = useState('{}')
  const [showContext, setShowContext] = useState(false)

  const fetchTestResults = async () => {
      await axios.get(`${API_URL}/tests?getResults&prompt_id=${prompt_id}&test_id=${test_id}&prompt_version=${prompt_version}&timestamp=${timestamp}`, {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`
        }
      }).then((res) => {
        setTestResults(res.data.results)
        setTestContext(res.data.test_context)
        setTestName(res.data.test_name)
      }).catch((err) => console.error(err))
      setIsFetchedTestResults(true)
  }

  // 2. fetch prompt data with version or timestamp from logs
  useEffect(() => {
    fetchTestResults()
  }, []);

  const crumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: `/tests`, breadcrumb: 'CI/CD' },
    { path: `/tests/${prompt_id}`, breadcrumb: `${prompt_id}` },
    { path: `/tests/${prompt_id}/${test_id}`, breadcrumb: testName },
    { path: window.location.href, breadcrumb: `${prompt_version}/${timestamp}` }
  ];

  const improvePrompt = async () => {
    await axios.post(
      `${API_URL}/tests?improvePrompt`,
      { 
        timestamp,
        prompt_id,
        prompt_version,
        test_id,
        
       },
      {
        headers: {
          Authorization: `Bearer ${auth.syncGetIdToken()}`,
          'Content-Type': 'application/json'
        }
      }
    ).then((res) => {
      alert("sent!")
    }).catch((err) => console.error(err))
  }

  return (
    <div className='flex flex-col w-full p-8 space-y-8'>
        <Breadcrumbs crumbs={crumbs} />
        {isFetchedTestResults ? <>
            <div className='flex gap-2 items-center'>
              <h2 className='text-xl font-bold'>{testName}</h2> 
              {testResults.passed ? <Check className='text-green-500 font-bold' size={24}/> : 
                <X className='text-red-500 font-bold' size={24}/>} 
            </div>
            
            <div style={{ marginTop: 10 }} className="flex items-center gap-2">
              {/* Grouped Buttons */}
              
              
              {/* Spacer */}
              {/* <div className="flex-grow"></div> */}
              
              {/* Right-aligned Button */}
              
              <Button className="mb-2 bg-blue-300" onClick={() => setShowContext(prev => !prev)}>{showContext ? "Hide" : "Show"} context</Button>
            </div>
            <div className='w-full flex gap-2'>
              <div className='min-w-[60%] w-full'>
                <div>
                      <h2 className='text-xl font-bold'>Prompt response:</h2>
                      <Textarea
                          disableAnimation  
                          disabled        
                          classNames={{
                            input: "resize-y min-h-[50vh]",
                          }} value={testResults.user_prompt_response} />
                  </div>
                  <div>
                      <h2 className='text-xl font-bold mt-5'>Ideal answer:</h2>
                      <Textarea
                          disabled
                          disableAnimation         
                          classNames={{
                            input: "resize-y min-h-[50vh]",
                          }} value={JSON.stringify(testResults.ideal_answer, null, 2)} />
                  </div>
                  <div>
                      <h2 className='text-xl font-bold mt-5'>Test results:</h2>
                      <Textarea
                          disabled
                          disableAnimation         
                          classNames={{
                            input: "resize-y min-h-[50vh]",
                          }} value={JSON.stringify(testResults.test_result, null, 2)} />
                  </div>
              </div>
                

                {showContext && <JsonEditorViewer initialJson={testContext} setContext={() => 1}/>}
            </div>
            <div className="flex items-center gap-2">
                <Button className="mb-2 bg-blue-300" onClick={() => window.open(`/tests/edit/${prompt_id}/${test_id}`)}>Edit test</Button>
                
                {/* <Button className="mb-2 bg-blue-200" onClick={() => improvePrompt()}>Improve prompt</Button> */}
              </div>
                
            <div className='flex gap-2 items-center justify-center'>
                <span className='text-2xl font-bold'>Score: {testResults.score}% / {testResults.threshold}%</span>
                {testResults.passed ? <Check className='text-green-500 font-bold' size={30}/> : 
                <X className='text-red-500 font-bold' size={30}/>}
            </div>
        </> : <Loader2 className='animate-spin' />}
    </div>
  );
};

export default VersionTestResult;
